/**
 * MathplanJob.status values come from the solver + workers (monitor, solution, import, cleanup).
 * "Terminal" here means: no further in-app progress to show; stop polling; do not auto-reopen the generator modal.
 *
 * @see planung-backend/src/workers/job/mathplan/monitor.ts
 * @see planung-backend/src/workers/job/mathplan/solution.ts
 * @see planung-backend/src/workers/job/mathplan/import.ts
 * @see planung-backend/src/workers/job/mathplan/cleanup.ts
 */

const SUCCESS: readonly string[] = ['IMPORTED', 'FINISHED'];
const FAILURE: readonly string[] = ['ERROR', 'FAILED', 'CANCELLED'];

/**
 * End states for a completed solve + import: modal closes, may reload cards.
 * Note: the monitor rewrites the solver "FINISHED" to "SOLVED" in the DB, so "FINISHED" is rarely stored but supported for safety.
 */
export function isMathplanJobSuccessTerminal(status: string): boolean {
  return SUCCESS.includes(status);
}

/** Hard failures: modal closes, no success reload. */
export function isMathplanJobFailureTerminal(status: string): boolean {
  return FAILURE.includes(status);
}

export function isMathplanJobTerminalForUi(status: string): boolean {
  return isMathplanJobSuccessTerminal(status) || isMathplanJobFailureTerminal(status);
}
